import React from 'react';
import { isEqual } from 'lodash-es';
import { useAppSelector, useAppDispatch } from '@/store';
import { fetchSources } from '@/store/slices/dataSources';

type ProcessListReturn = any;

export const useProcessList = (
  dataSourceList: any,
  language: string,
  dsId: string,
  maxItems: number,
): ProcessListReturn => {
  const cacheRef = React.useRef<any>(null);
  const [state, setState] = React.useState<any>({
    data: [],
    dsId: dsId ?? dataSourceList?.id ?? null, // unique key for memoization; ideally every instance of this hook should have a unique dsId
    changed: 1,
    processed: false,
  });

  React.useEffect(() => {
    if (Array.isArray(dataSourceList?.data)) {
      if (!isEqual(cacheRef.current, dataSourceList?.data)) {
        cacheRef.current = dataSourceList?.data;
        setState((v: any) => ({
          dsId: v.dsId,
          data: dataSourceList?.data,
          changed: v.changed + 1,
          processed: true,
        }));
      }
    }
  }, [dsId, dataSourceList, language]);

  return state;
};

export const useDataSourceSelector = (dsId: string) => {
  const cachedDS = React.useRef<any>(null);
  const [dataSource, setDataSource] = React.useState<any>(null);
  const dataSourceList = useAppSelector((state: any) => state.dataSources.items[dsId]);
  const authenticationToken = useAppSelector((state) => state.authentication.access_token);
  const fetched = React.useRef(false);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (dataSourceList && !isEqual(dataSourceList, cachedDS.current)) {
      cachedDS.current = dataSourceList;
      setDataSource(dataSourceList);
    } else if (!dataSourceList && dsId && !fetched.current && authenticationToken) {
        fetched.current = true;
        dispatch(fetchSources({ ids: [dsId] }));
      }
  }, [dsId, dataSourceList, dispatch, authenticationToken]);

  return dataSource;
};
